// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2wanN","imageUploader":"EGiftCard_imageUploader__2jrUf"};